import React, { useState } from "react";
import {
  Typography,
  Collapse,
  IconButton,
  Card,
  CardContent,
  Box,
  Container,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ScrollToTopButton from "./Utilities/ScrollToTopButton";
import { Helmet } from "react-helmet-async";

const faqs = [
  {
    question: "What documents are required to open a Forex trading account?",
    answer:
      "To open an account, you need a valid government-issued ID (such as a passport, Aadhaar card, or driver’s license) and a proof of address like a utility bill or bank statement.",
  },
  {
    question: "Can I open a trading account without verification?",
    answer:
      "You can register an account easily, but full verification (KYC) is required to access all features such as deposits, withdrawals, and live trading.",
  },
  {
    question: "How long does it take to open a Forex trading account?",
    answer:
      "Account registration takes just a few minutes. Verification typically takes a few hours up to 24 hours, depending on document approval.",
  },
  {
    question: "Is there a minimum deposit required to activate my account?",
    answer:
      "Yes, a minimum deposit is required to start live trading. The amount depends on the account type you choose.",
  },
  {
    question: "Can I use the same account on multiple devices?",
    answer:
      "Yes, you can securely access your trading account from desktop, tablet, or mobile using the same login credentials.",
  },
  {
    question: "Can I open a demo account before trading live?",
    answer:
      "Yes, demo accounts are available so you can practice trading strategies using virtual funds before switching to a live account.",
  },
  {
    question: "Can I update my personal details after registration?",
    answer:
      "Yes, you can update certain details through your profile settings. Some changes may require re-verification.",
  },
  {
    question: "What should I do if my account verification fails?",
    answer:
      "Ensure your documents are clear, valid, and match your registered details. You can re-upload documents or contact support for assistance.",
  },
  {
    question: "Is my account information secure?",
    answer:
      "Yes, your data is protected using advanced encryption and security protocols to ensure privacy and safety.",
  },
  {
    question: "Can I have multiple trading accounts under one profile?",
    answer:
      "Yes, you can create and manage multiple accounts (if supported) based on different trading needs or strategies.",
  },
];

const AccountCMfaq = () => {
  const [openIndex, setOpenIndex] = useState(0);

  const handleToggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
      <>
      <Helmet>
        <link rel="canonical" href="https://www.hcfinvest.com/accountcmfaq" />
      </Helmet>
            <Container sx={{ backgroundColor: "#fff" }} maxWidth={false} disableGutters>
      <ScrollToTopButton/>
      <Box
        sx={{
          position: "relative",
          height: "475px",
          display: "flex",
          flexDirection: "column", // 👈 Stack text vertically
          alignItems: "center",
          justifyContent: "center",
          color: "white",
          backgroundImage: `url('Images/HelpCenterImages/Newhedgecapitalsimage_Helpcenter 1.jpg')`, // 👈 replace with your image path
          backgroundSize: "cover",
          backgroundPosition: "center",
          marginBottom: "30px",
          textAlign: "center",
        }}
      >
        <h1
          // variant="h3"
          // component="h1"
          sx={{
            zIndex: 2,
            fontWeight: 600,
            textAlign: "center",
            px: 2,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          Account Creation & Management
        </h1>

        <h3
          // variant="h5"
          sx={{
            zIndex: 2,
            fontWeight: 600,
            textAlign: "center",
            px: 2,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          Start Trading with Ease and Manage Your Investments Seamlessly
        </h3>
      </Box>

      <Typography
      variant="h2"
        sx={{
          marginBottom: "50px",
          fontWeight: "600",
          fontSize: "2.5rem",
          color: "#101828",
        }}
      >
        FAQ
      </Typography>

      <Box sx={{ maxWidth: "1200px", margin: "40px auto" }}>
        {faqs.map((faq, index) => (
          <Card
            key={index}
            sx={{
              mb: 2,
              boxShadow: 2,
              borderRadius: 2,
              backgroundColor: "#fff",
              cursor: "pointer",
            }}
            onClick={() => handleToggle(index)}
          >
            <CardContent>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Typography variant="h6" fontWeight="bold">
                  {faq.question}
                </Typography>
                <IconButton>
                  <ExpandMoreIcon
                    sx={{
                      transform:
                        openIndex === index ? "rotate(180deg)" : "rotate(0deg)",
                      transition: "transform 0.3s ease",
                    }}
                  />
                </IconButton>
              </Box>

              <Collapse in={openIndex === index} timeout="auto" unmountOnExit>
                <Typography
                  variant="body1"
                  sx={{
                    mt: 2,
                    color: "text.secondary",
                    lineHeight: 1.7,
                    textAlign: "left",
                  }}
                >
                  {faq.answer}
                </Typography>
              </Collapse>
            </CardContent>
          </Card>
        ))}
      </Box>
    </Container>
      </>
  );
};

export default AccountCMfaq;
